<app-main-header [name_main]="'Proyectos Cvat'">

</app-main-header> 
<app-data-table
    [data]="cvatService.projects()" 
    [columns]="columns" 
    [rows]="50" 
    [rowsPerPageOptions]="[10, 25, 50]" 
    (rowSelect)="onRowSelect($event)" 
    [selection]="selectedItems" 
    (selectionChange)="onSelectionChange($event)"
    [sortField]="'cvat'"
    [sortOrder]="-1"
    [showFilters]="true"
    (deleteItems)="onDeleteItems($event)"
    [viewDetails]="true"
    (seeDetails)="onSeeDetails($event)"
    [optional]="false"
    [deleteButton]="true">
</app-data-table> 
